import { Section } from "../../styles/reusables";
import styled from "styled-components";
import { motion } from "framer-motion";
import { v, b } from "../../styles/variables";

export const SkillSection = styled(Section)`
	> div {
		flex-basis: 50%;
	}

	align-items: flex-start;
	justify-content: flex-start;
`;

export const Skills = styled(motion.div)`
	display: flex;
	flex-wrap: wrap;
	row-gap: ${v.mediumDist};
	justify-content: space-between;

	@media ${b.medium} {
		> div {
			flex: 0 0 40%;
		}
	}
`;
